import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import MultilingualInputLanguages from "components/Common/MultilingualInputLanguages";
import DebouncedInput from "components/Common/DebouncedInput";
import { bindActionCreators } from "redux";
import { getResource, getResources } from "selectors/resources";
import { Client, Language } from "resourceModels";
import { BaseGreeting } from "components/Pages/Settings/SettingsGreetings/reducer";
import { VALID_CHARACTER_AMOUNT } from "constants/greetings";
import {
  addLanguage as addLanguageAction
} from "components/Common/MultilingualInputLanguages/actions";
import {
  deleteLanguage as deleteLanguageAction
} from "components/Pages/Settings/SettingsGreetings/actions";
import GreetingEmojiList from "./GreetingEmojiList";

class GreetingMessageBody extends React.Component {
  constructor(...args) {
    super(...args);

    this.handleDeleteLanguage = this.handleDeleteLanguage.bind(this);
    this.handleAddLanguage = this.handleAddLanguage.bind(this);
  }

  /**
   * Properties
   */

  /**
   * @returns {String|null}
   */
  get activeLanguage() {
    return this.getValue("activeLanguage") || null;
  }

  /**
   * Methods
   */

  /**
   * @param {String[]} keys
   * @returns {*}
   */
  getValue(...keys) {
    const { greeting } = this.props;

    return greeting.getIn(keys);
  }

  /**
   * Handlers
   */

  /**
   * @param {String} languageCode
   */
  handleAddLanguage(languageCode) {
    const { addLanguage, greeting } = this.props;
    addLanguage(languageCode, null, greeting.id);
  }

  /**
   * @param {String} languageCode
   */
  handleDeleteLanguage(languageCode) {
    const {
      /** @type Client */
      client,
      greeting,
      deleteLanguage
    } = this.props;

    deleteLanguage(greeting.id, languageCode, client.language);
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      /** @type Client */
      client,
      languages
    } = this.props;

    return (
      <div className="Greeting__left-column__message">
        {this.getValue("style") === "Text" && (
          <div className="Greeting__left-column__message__wrapper">
            <div className="Greeting__left-column__wrapper">
              <span className="Greeting__left-column__label">
                Message Text
              </span>
              {client.features.get("translations") && (
                <MultilingualInputLanguages
                  responseId="GREETINGID"
                  customClassName="Greeting__languages"
                  message={this.getValue("body", "messageText")}
                  setActiveLanguage={this.props.setActiveLanguage}
                  activeLanguage={this.activeLanguage}
                  greetingId={this.getValue("id")}
                  invalidFields={this.getValue("invalidFields")}
                  addLanguage={this.handleAddLanguage}
                  deleteLanguage={this.handleDeleteLanguage}
                />
              )}
            </div>
            {Boolean(languages) && (
              <div>
                <DebouncedInput
                  customClassName="Greeting__left-column__message__text"
                  type="text"
                  value={
                    this.getValue("body", "messageText", this.getValue("activeLanguage")) || ""
                  }
                  onChange={this.props.handleMessageInput}
                  placeholder="Add your greeting message here!"
                  isTextArea
                  debounceTime={0}
                  characterCounter={VALID_CHARACTER_AMOUNT}
                  isInvalid={this.getValue("invalidFields").contains(this.activeLanguage)}
                />
              </div>
            )}
            {this.getValue("invalidFields").includes("bodyLength") && (
              <div className="Greeting__left-column__message__past-char-limit">
                Too long
              </div>
            )}
          </div>
        )}
        {this.getValue("style") === "Emoji" && (
          <div className="Greeting__left-column__message__wrapper">
            <span className="Greeting__left-column__label">
              Emoji
            </span>
            <div className="Greeting__left-column__message__emoji__wrapper">
              <GreetingEmojiList
                selectedEmoji={this.props.selectedEmoji}
                emojiList={this.props.emojiList}
                handleEmojiSelect={this.props.handleEmojiSelect}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

GreetingMessageBody.propTypes = {
  client: PropTypes.instanceOf(Client).isRequired,
  greeting: PropTypes.instanceOf(BaseGreeting).isRequired,
  languages: ImmutablePropTypes.listOf(PropTypes.instanceOf(Language)).isRequired,
  selectedEmoji: PropTypes.string.isRequired,
  emojiList: ImmutablePropTypes.map.isRequired,
  handleEmojiSelect: PropTypes.func.isRequired,
  setActiveLanguage: PropTypes.func.isRequired,
  handleMessageInput: PropTypes.func.isRequired,
  addLanguage: PropTypes.func.isRequired,
  deleteLanguage: PropTypes.func.isRequired
};

/**
 * @param {Object} state
 * @returns {Object}
 */
function mapStateToProps(state) {
  return {
    client: getResource(state, "client"),
    languages: getResources(state, "language")
  };
}

function mapDispatch(dispatch) {
  return {
    addLanguage: bindActionCreators(addLanguageAction, dispatch),
    deleteLanguage: bindActionCreators(deleteLanguageAction, dispatch)
  };
}

const Connector = connect(mapStateToProps, mapDispatch)(GreetingMessageBody);

Connector.propTypes = {
  greeting: PropTypes.instanceOf(BaseGreeting).isRequired
};

export default Connector;
export { GreetingMessageBody };
